import { useCallback, useEffect, useState } from 'react';
import ViewReport from '../../components/Reports/ViewReport/ViewReport';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import { useData } from '../../hooks/useData';
import { NavItem } from '../../types/appModels';
import { Alignment, DataStatus, StatusUtil } from '../../types/appTypes';
import Card from '../../components/Common/Card/Card';
import Container from '../../components/Common/Container/Container';
import Spinner from '../../components/Common/Spinner/Spinner';
import StatusText from '../../components/Common/StatusText/StatusText';
import { FaExclamationTriangle } from 'react-icons/fa';

const ViewPage = () => {
  const [embedError, setEmbedError] = useState(false);
  const { hash } = useLocation();
  const nav = useNavigate();

  const { dataState: navDataState } = useData<NavItem[]>({
    endpoint: process.env.REACT_APP_API_NAVIGATION!,
    initialData: [],
    loadWhen: hash === null || hash.substring(1) === '',
  });
  const { dataState: pathDataState } = useData<string>({
    endpoint: `${process.env.REACT_APP_API_DECRYPT}?ev=${
      hash?.substring(1) ?? ''
    }`,
    loadWhen: hash !== null && hash.substring(1) !== '',
    rawResponse: true,
  });

  const [searchParams] = useSearchParams();
  const reportParams = searchParams.get('params') ?? undefined;

  useEffect(() => {
    if (
      (hash === null || hash.substring(1) === '') &&
      navDataState.data !== undefined &&
      navDataState.data.length > 0
    ) {
      const defaultNavItem = navDataState.data.find(
        (navItem) => navItem.defaultView
      );
      if (defaultNavItem !== undefined) {
        let redir = defaultNavItem.value;

        if (reportParams !== undefined && reportParams !== '') {
          redir = `${defaultNavItem.path}?params=${encodeURIComponent(
            reportParams
          )}`;
          if (defaultNavItem.hash !== undefined) {
            redir += `#${encodeURIComponent(defaultNavItem.hash)}`;
          }
        }

        nav(redir);
      }
    }
  }, [hash, navDataState.data, nav, reportParams]);

  const embedErrorHandler = useCallback(() => {
    setEmbedError(true);
  }, []);

  let display: JSX.Element = <></>;
  if (
    navDataState.status === DataStatus.Loading ||
    pathDataState.status === DataStatus.Loading
  ) {
    display = (
      <Card flexDirection='column'>
        <Container alignment={Alignment.Center}>
          <Spinner />
        </Container>
      </Card>
    );
  }
  if (
    StatusUtil.isFail(navDataState.status) ||
    StatusUtil.isFail(pathDataState.status)
  ) {
    display = (
      <Card flexDirection='column'>
        <Container alignment={Alignment.Center}>
          <StatusText
            text='An error occurred and the report could not be loaded.'
            error={true}
            icon={<FaExclamationTriangle />}
          />
        </Container>
      </Card>
    );
  }
  if (pathDataState.status === DataStatus.Ready) {
    display = (
      <ViewReport
        reportPath={pathDataState.data}
        encryptedReportParams={reportParams}
        onEmbedError={embedErrorHandler}
      />
    );
  }

  return <FullScreen hideHeader={!embedError}>{display}</FullScreen>;
};

export default ViewPage;
